// extracted by mini-css-extract-plugin
export default {"container":"ClaimResult_container__px4Sr","inspectionResultSwitch":"ClaimResult_inspectionResultSwitch__QjoTm","loading":"ClaimResult_loading__XofOg"};